import React from "react";
import { useTranslation } from "react-i18next";

const AppAlert = ({type = "primary", icon, children, onClose = () => null, ...props}) => {
    const { t } = useTranslation();
    return (
        <>
            <div className={`alert alert-${type} alert-dismissible text-left font-weight-bold`} role="alert">
                <button type="button" onClick={onClose} className="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
                {icon && <i className={`fa ${icon}`}/>}
                {typeof children === 'string' ? t(children) : children}
            </div>
        </>
    )
}

export default AppAlert;